<div class="app-frame mat-app-background">
  <app-toolbar></app-toolbar>
  <main class="content">
    <router-outlet></router-outlet>
  </main>
  <app-footer [ngClass]="isFullscreen ? 'padded-bottom' : ''"></app-footer>
</div>